import logo from "../assets/images/logodev.png";
import { NavLink } from "react-router-dom";

function Footer() {
  const handlemail = () => {
    window.location.href = "mailto:davidwele76@gmail.com subject=Votre%20sujet";
  };
  const handlecall = () => {
    window.location.href = "tel:+257 69619884";
  };
  const rediPintrest = () => {
    window.location.href = "https://pin.it/1agZp2YNs";
  };

  const rediFacebook = () => {
    window.location.href = "https://www.facebook.com/devdavid.welengenzu.3";
  };

  const rediInstagram = () => {
    window.location.href =
      "https://www.instagram.com/dev__well/profilecard/?igsh=czc4dXlucmU1aWx1";
  };

  const rediLinkdin = () => {
    window.location.href = " https://www.linkedin.com/in/david-wele-b4509621b";
  };

  return (
    <footer
      className="bg-gray-300 dark:bg-[#010138] pl-10 md:pl-5 dark:text-white text-blue-600 p-4 text-center shadow-2xl space-y-6
    "
    >
      {" "}
      <div className=" md:flex md:flex-row md:justify-around md:items-start grid grid-cols-2 gap-5 ">
        <div className=" flex flex-col justify-start items-start ">
          <h1 className=" md:text-xl text-[14px] font-bold">Nous contacter</h1>
          <button onClick={handlecall}>
            <div className=" flex flex-row justify-center items-center space-x-2 md:space-x-1">
              <div className="">
                <i className="fas fa-phone text-[14px] md:text-[18px]"></i>
              </div>
              <div className=" text-[12px] md:text-[16px]">
                <p>+257 69619884</p>
              </div>
            </div>
          </button>
          <button onClick={handlemail}>
            <div className=" flex flex-row justify-center items-center space-x-2">
              <div>
                <i className="fas fa-envelope text-[14px] md:text-[18px]"></i>
              </div>
              <div className="text-[12px] md:text-[16px]">
                <p>davidwele76@gmail.com</p>
              </div>
            </div>
          </button>
          <div className=" flex flex-row justify-center items-center space-x-2">
            <div>
              <i className="fas fa-location-dot text-[14px] md:text-[18px]"></i>
            </div>
            <div className=" text-[12px] md:text-[16px] ">
              <p>Bujumbura/ Av.Ngagara/10</p>
            </div>
          </div>
        </div>

        <div className=" flex flex-col justify-start items-start">
          <h1 className=" md:text-xl text-[14px] font-bold">Nos services</h1>
          <NavLink to="/" className=" ">
            <button className=" text-[12px] md:text-[16px]">Homme</button>
          </NavLink>{" "}
          <NavLink to="/about">
            <button className=" text-[12px] md:text-[16px]">À propos</button>
          </NavLink>
          <button className=" text-[12px] md:text-[16px]">features</button>
        </div>

        <div className=" flex flex-col justify-start items-start">
          <h1 className=" md:text-xl text-[14px] font-bold">Liens rapide</h1>
          <button className=" text-[12px] md:text-[16px]">
            Base du savoir
          </button>
          <button className=" text-[12px] md:text-[16px]">
            Notre expérience
          </button>
          <button className=" text-[12px] md:text-[16px]">FAQ</button>
          <NavLink to="/Contact">
            <button className=" text-[12px] md:text-[16px]">Contact</button>
          </NavLink>
        </div>

        <div className="">
          <div className=" flex flex-row justify-start items-center">
            <div className="text-xl font-bold">
              <h1 className="md:text-xl text-[15px] font-bold">devdesign</h1>
            </div>
            <div>
              <img src={logo} alt="" width={60} height={60} />
            </div>
          </div>
          <div className=" flex flex-col justify-start items-start w-40 md:w-72 pr-10 md:pr-5">
            <p className="  text-wrap text-[12px] md:text-lg mr-1 text-justify">
              Nous somme une solution pour vos supports de communucation et
              solutions téchnologique.
            </p>
          </div>
        </div>
      </div>
      <div className=" flex flex-col justify-center items-center ">
        <div>
          <p className=" md:text-lg text-[14px]">
            Copyright &copy;2025 Tous droits réservés|
            <strong>dev well</strong>.
          </p>{" "}
        </div>
        <div
          className=" flex flex-row justify-center space-x-4 mt-0 rounded-b-lg shadow-lg
            text-2xl font-bold text-blue-600  p-3 w-[350px]"
        >
          <div>
            <button onClick={rediFacebook}>
              <i className=" fab fa-facebook"></i>
            </button>
          </div>
          <div>
            <button onClick={rediInstagram}>
              <i className=" fab fa-instagram"></i>
            </button>
          </div>
          <div>
            <button onClick={rediPintrest}>
              <i className=" fab fa-pinterest"></i>
            </button>
          </div>
          <div>
            <button onClick={rediLinkdin}>
              <i className=" fab fa-linkedin"></i>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
export default Footer;
